import { el, setChildren } from 'redom';

import HeltapEditor from '../../../../helpers';

import ColumnsOrderPanel from './columns-order-panel';
import NavigationSettingsPanel from './navigation-settings-panel';
import MiscellaneousSettingsPanel from './miscellaneous-settings-panel';

import './index.scss';

class AdvancedColumnsSettings {

  constructor(configuration) {

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;
    this.parentEntityId = configuration.parentEntityId;
    this.menu = configuration.menu;

    this.columnsOrderPanel = null;
    this.navigationSettingsPanel = null;

    this.el = el('#advanced-columns-settings-main', [
      el('ht-spinner', { size: 'small' })
    ]);

  }

  handleColumnsOrderChange(positions) {

    HeltapEditor.multipleColumns.updateColumnsOrder(this.editor, this.activeNodePath, positions);

  }

  handleNavigationSettingsChange(navigationSettings) {

    HeltapEditor.multipleColumns.updateNavigationSettings(this.editor, this.activeNodePath, navigationSettings);

  }

  handleMiscellaneousSettingsChange(settings) {

    HeltapEditor.multipleColumns.updateMiscellaneousSettings(this.editor, this.activeNodePath, settings);

  }

  renderColumnsOrderPanel() {

    this.columnsOrderPanel = new ColumnsOrderPanel({
      menu: this.menu,
      node: this.node,
      onChange: this.handleColumnsOrderChange.bind(this)
    });

    return this.columnsOrderPanel;

  }

  renderNavigationSettingsPanel() {

    this.navigationSettingsPanel = new NavigationSettingsPanel({
      menu: this.menu,
      node: this.node,
      onChange: this.handleNavigationSettingsChange.bind(this)
    });

    return this.navigationSettingsPanel;

  }

  renderMiscellaneousSettingsPanel() {

    this.miscellaneourSettingsPanel = new MiscellaneousSettingsPanel({
      menu: this.menu,
      node: this.node,
      onChange: this.handleMiscellaneousSettingsChange.bind(this)
    });

    return this.miscellaneourSettingsPanel;

  }

  async initialize() {

    setChildren(this.el, [
      this.renderColumnsOrderPanel(),
      this.renderNavigationSettingsPanel(),
      this.renderMiscellaneousSettingsPanel()
    ]);

  }

  onmount() {

    this.initialize();

  }

  update(configuration) {

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;
    this.parentEntityId = configuration.parentEntityId;

    // this.columnsOrderPanel.update({ menu: this.menu, node: this.node });

  }

}

export default AdvancedColumnsSettings;